import { useQuery } from 'react-query';

import { getContractTagsInit as queryFn } from 'api/endPoints/getContractTagsInit';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTagListInit = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getTagListInit'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
    });
};

export interface QueryParams {
    projectId?: number;
}

interface QueryResponse {
    tags: { id: number; name: string }[];
}
